module.exports = __webpack_public_path__ + "img/赛区球-1.baa756c2.png";